import { ErrorViewProps } from "./ErrorView.types"
import "./ErrorView.css"
import ErrorIcon from "../../../../media/ErrorIcon";

export function ErrorView(props: ErrorViewProps) {

  const { message } = props
  return (
    <div className="analysis-section">
      <div className="error-section-content">
        <ErrorIcon />
        <p className="error-section-message">{message}</p>
      </div>
    </div>
  );
}

export default ErrorView